var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3628 5.65201L15.8428 4.17201C16.0285 3.98621 16.2491 3.83882 16.4918 3.73826C16.7345 3.6377 16.9946 3.58594 17.2573 3.58594C17.52 3.58594 17.7802 3.6377 18.0229 3.73826C18.2656 3.83882 18.4861 3.98621 18.6718 4.17201L20.0858 5.58601C20.4608 5.96107 20.6714 6.46968 20.6714 7.00001C20.6714 7.53034 20.4608 8.03895 20.0858 8.41401L18.6058 9.89401M14.3628 5.65201L4.74681 15.267C4.41479 15.599 4.21018 16.0373 4.16881 16.505L3.92681 19.245C3.91381 19.3907 3.93292 19.5374 3.98279 19.6749C4.03265 19.8123 4.11206 19.9372 4.21542 20.0407C4.31878 20.1441 4.44357 20.2236 4.58099 20.2736C4.71842 20.3236 4.86514 20.3429 5.01081 20.33L7.75081 20.088C8.21924 20.0471 8.65827 19.8425 8.99081 19.51L18.6058 9.89401M14.3628 5.65201L18.6058 9.89401",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.00d18e2ad44be134ba56877adb13c853.svg";
export { ForwardRef as ReactComponent };